var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.363 0.507598C10.7534 0.116864 11.3868 0.116752 11.7774 0.507348L18.8251 7.55467C19.2154 7.945 19.2157 8.57781 18.8256 8.96842L18.4308 9.36377C18.1628 9.63209 17.7661 9.72577 17.4064 9.60565L16.8403 9.41658L14.1455 12.1079L19.5926 17.5547C19.9832 17.9452 19.9832 18.5784 19.5926 18.969L19.4687 19.0929C19.0781 19.4835 18.4449 19.4834 18.0544 19.0929L12.6083 13.6461L9.99302 16.2613L10.1635 16.9432C10.2487 17.2841 10.1488 17.6447 9.9002 17.8931L9.4686 18.3244C9.07804 18.7147 8.4451 18.7145 8.05467 18.3241L1.00722 11.2771C0.616571 10.8864 0.616683 10.2531 1.00747 9.86257L1.43906 9.43132C1.68733 9.18323 2.04748 9.08347 2.38801 9.16844L3.06852 9.33826L9.91578 2.49246L9.7269 1.92533C9.60728 1.56617 9.70074 1.17025 9.96833 0.902479L10.363 0.507598ZM11.8392 3.64666L4.14663 11.3377L7.99236 15.1843L15.6849 7.49328L11.8392 3.64666Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction);
export default __webpack_public_path__ + "static/media/auction.79720447.svg";
export { ForwardRef as ReactComponent };